import React, { createContext, useMemo, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Program, useProgram } from '../data/useProgram';

export interface ProgramDetails {
  program: Program | undefined;
  isLoadingProgram: boolean;
  isFetchingProgram: boolean;
  programError: unknown;
  isProgramError: boolean;
}

const programDetailsContext = createContext<ProgramDetails | undefined>(undefined);

export const ProgramDetailsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const id = useParams().id as string;

  const { isLoadingProgram, isFetchingProgram, programError, program, isProgramError } = useProgram(id);

  const value = useMemo(
    () => ({
      program,
      isLoadingProgram,
      isFetchingProgram,
      programError,
      isProgramError,
    }),
    [program, isLoadingProgram, isFetchingProgram, programError, isProgramError]
  );

  return <programDetailsContext.Provider value={value}>{children}</programDetailsContext.Provider>;
};

export const useProgramDetails = () => {
  const context = useContext(programDetailsContext);
  if (!context) {
    throw new Error('useProgramDetails must be used within ProgramDetailsContextProvider');
  }
  return context;
};
